export default __webpack_public_path__ + "static/media/HRSir.6788d408.webp";